<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>
          <page-title title="You're Almost Done" />
          <hr />

          <p><strong>You're almost done.</strong></p>
          <p>There's one final step - click the "Complete Survey" button below. Once you submit the survey, you will not be able to make any more changes to it.</p>

          <b-form @submit.prevent="finalize">
            <b-button type="submit" variant="primary">Complete Survey</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'ClientReview',
  props: [
    'formId'
  ],
  data() {
    return {
      form: null
    }
  },
  methods: {
    load: function () {
      axios
        .get('/api/form/' + this.formId)
        .then(response => {
          console.log(response);

          // TODO: Check for 200?

          this.form = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    finalize: function () {
      console.log('finalize');
      axios
        .post('/api/form/' + this.formId + '/finalize', {})
        .then(response => {
          console.log(response);

          // TODO: Check for 200?

          this.$router.push('/client/form/' + this.formId + '/final');
        })
        .catch(error => {
          console.log(error);
        });

    }
  },
  watch: {
  },
  created() {
  },
  async mounted () {
    this.load();
  }}
</script>